import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { getCustomFieldLabel } from 'modules/settings/lib/custom_fields'

interface CustomFieldProps {
  customField: Record<string, any>
}

export default function CustomField({ customField }: CustomFieldProps) {
  return (
    <>
      <Text.Normal color="grey1000" weight="medium" size="200" whiteSpace="breakSpaces">
        {customField.label}
      </Text.Normal>
      <Box flexDirection="row" gap="s24">
        <Text.Normal weight="medium" size="200" color="grey600">
          {getCustomFieldLabel(customField.field_type)}
        </Text.Normal>
        {customField.required && (
          <Text.Normal weight="medium" size="200" color="grey600">
            {i18n.t('surveys.form.question_configs.required')}
          </Text.Normal>
        )}
      </Box>
    </>
  )
}
